/* eslint-disable */
export default {
  createLog: 'Protokoll erstell.',
  creating: 'Erstellen',
  save: 'Speichern',
  saving: 'Wird gespeichert',
  saved: 'Gespeichert',
  view: 'Anzeigen',
  creatingFailed: 'Erstellen fehlgeschlagen.',
  savingFailed: 'Speichern fehlgeschlagen.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
